import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import './Toast.module.scss';

// Define a reusable function to show toast notifications
const MLToast = () => {
  const showToast = (message, type = 'default', duration = 3000) => {
    switch (type) {
      case 'success':
        toast.success(message, { autoClose: duration });
        break;
      case 'error':
        toast.error(message, { autoClose: duration });
        break;
      case 'info':
        toast.info(message, { autoClose: duration });
        break;
      case 'warning':
        toast.warning(message, { autoClose: duration });
        break;
      default:
        toast(message, { autoClose: duration });
        break;
    }
  };

  return { showToast };
};

export default MLToast;
